/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MovableItemList } from '../../models/movable-item-list';

export interface WarehouseControllerGetLoadedSerialNumbers$Params {
  related_order_id: number;
  product_id: number;
  related_warehouse_id?: number;
  limit: number;
  skip: number;
}

export function warehouseControllerGetLoadedSerialNumbers(http: HttpClient, rootUrl: string, params: WarehouseControllerGetLoadedSerialNumbers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovableItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerGetLoadedSerialNumbers.PATH, 'get');
  if (params) {
    rb.query('related_order_id', params.related_order_id, {});
    rb.query('product_id', params.product_id, {});
    rb.query('related_warehouse_id', params.related_warehouse_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MovableItemList;
      }>;
    })
  );
}

warehouseControllerGetLoadedSerialNumbers.PATH = '/warehouse/loaded-serial-numbers';
